/* eslint-disable */

import React, { Component } from 'react';
import ReactMarkdown from 'lib/react-markdown';
import { Link } from 'react-router-dom';
import RecipeCard from 'routes/Products/components/RecipeCard';
import { Container, Row, Col, Button } from 'reactstrap';
import * as styles from 'styles/index.scss';
import { track } from '../../../../lib/track';
//FIXME this could/should be a container

const { recipesListContainer, recipesListTitle, recipesListRecipes } = styles;

class RecipesList extends Component {
  render() {
    const path = location.pathname.split('/');
    const { description } = this.props.data || {};
    const { colSizes, Children, userAnalytics, isUnstructured = false } = this.props;

    let thisProductInPath = path[2];
    const { disableViewAll } = this.props;

    return (
      <div className={this.props.className}>
        {Children.length ? (
          <Row className="align-items-end">
            <Col xs="auto">
              <h4>Recipes to Try</h4>
            </Col>
          </Row>
        ) : null}
        <Row className={`${recipesListRecipes} justify-content-center`} style={{ padding: 0 }}>
          {Children.map((recipe, i) => {
            return (
              <Col {...colSizes}>
                <RecipeCard {...recipe} className="h-100" />
              </Col>
            );
          })}
        </Row>
        {!isUnstructured && (
          <Row>
            <Button
              onClick={() => track('VIEW_ALL_RECIPES_CLICK', userAnalytics || { service: 'default' })}
              block
              color="primary"
              size="lg"
              tag="a"
              href={`/products/${thisProductInPath}/recipes`}
            >
              View all recipes
            </Button>
          </Row>
        )}
      </div>
    );
  }
}

export default RecipesList;
